import { useEditor } from '@craftjs/core';
import { SliderField } from '../SliderField/SliderField';
import type { FormProps } from '@builder4/shared/components/Form';
import { useInspectorNode } from '@/hooks/useInspectorNode';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { FORM_NODE_NAME } from '@/utils/constants';

const NodeFieldLabelSize = () => {
  const { actions } = useEditor();
  const { id, props: nodeProps, node } = useInspectorNode<Partial<FormProps>>();

  const { getBPProp, setBPProp } = useBreakpointAwareProp(node?.data.displayName || FORM_NODE_NAME);

  // Read props using breakpoint-aware getter
  const fieldLabelFontSize = getBPProp(nodeProps, 'fieldLabelFontSize');

  const parseFontSize = (size?: string): number => {
    if (!size) return 10;
    return parseInt(size.replace('px', ''), 10) || 10;
  };

  const handleChange = (value: number) => {
    const newSize = `${value}px`;
    actions.history.ignore().setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldLabelFontSize', newSize, FORM_NODE_NAME);
    });
  };

  const handleChangeComplete = (value: number, initialValue: number) => {
    actions.history.ignore().setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldLabelFontSize', `${initialValue}px`, FORM_NODE_NAME);
    });
    actions.setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldLabelFontSize', `${value}px`, FORM_NODE_NAME);
    });
  };

  return (
    <SliderField
      label="Size"
      value={parseFontSize(fieldLabelFontSize)}
      onChange={handleChange}
      onChangeComplete={handleChangeComplete}
      min={8}
      max={48}
    />
  );
};

export default NodeFieldLabelSize;
